import { useMsal } from '@azure/msal-react';
import { Button, makeStyles, Text } from '@fluentui/react-components';
import { DismissFilled } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useStores } from '../../common/hooks';
import { RoutePaths } from '../../route-paths';
import { FlexBox } from './flex-box';
import { SwitchProfilesModal } from './SwitchProfilesModal';
import './UserImpersonatedBanner.scss';

const useStyles = makeStyles({
  exitButton: {
    color: '#FFFFFF',
  }
});

const UserImpersonatedBannerImpl: React.FC = () => {
  const { instance } = useMsal();
  const {
    userStore,
    apiStore,
  } = useStores();
  const [isSwitchingProfilesModalOpen, setIsSwitchingProfilesModalOpen] = useState<boolean>(false);
  const classes = useStyles();

  const navigate = useNavigate();

  const endUserImpersonation = async (): Promise<void> => {
    try {
      await apiStore.endUserImpersonation(instance);
    } catch (error) {
      // TODO: handle error
    }
  };

  const getUserImpersonation = async (): Promise<void> => {
    try {
      const selectedRole = await apiStore.getUserImpersonation(instance);
      userStore.setSelectedRole(selectedRole);
    } catch (error) {
      // TODO: handle error
    }
  };

  const handleExitProfile = async (): Promise<void> => {
    await endUserImpersonation();
    await getUserImpersonation();
    navigate(RoutePaths.Home, { replace: true });
  };

  return (
    <FlexBox
      className='user-impersonated-banner'
      wrap
    >
      <Button
        appearance='outline'
        className={classes.exitButton}
        onClick={() => handleExitProfile()}
        icon={<DismissFilled />}
        iconPosition='after'
      >
        Exit profile
      </Button>
      <FlexBox
        aligns='center'
        content='center'
        wrap
        className='user-impersonated-banner__info'
      >
        <Text>You are currently using profile: {userStore.profileDisplayName}</Text>
        <Button
          appearance='secondary'
          className='button--switch-profile'
          onClick={() => {
            setIsSwitchingProfilesModalOpen(true);
          }}
        >
          Switch profile
        </Button>
      </FlexBox>
      {
        isSwitchingProfilesModalOpen &&
        <SwitchProfilesModal
          isOpen={isSwitchingProfilesModalOpen}
          onDismiss={() => setIsSwitchingProfilesModalOpen(false)}
        />
      }
    </FlexBox>
  );
};

export const UserImpersonatedBanner = observer(UserImpersonatedBannerImpl);